import Vue from 'vue';

import Router from 'vue-router';

import hrLogin from './views/hrLogin.vue';
import interpage from './views/interpage.vue';
import Login from './views/Login.vue';

Vue.use(Router)
export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: interpage,
    },
    {
      path: '/interpage',
      name: 'interpage',
      component: interpage,
      meta: {
        title: '悦享工资条',
      },
    },
    {
      path: '/down',
      name: 'down',
      component: () => import('./views/download.vue'),
      meta: {
        title: '下载',
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录',
      },
    },
    {
      path: '/hrLogin',
      name: 'hrLogin',
      component: hrLogin,
      meta: {
        title: '悦享人事',
      },
    },
    {
      path: '/hrAbout',
      name: 'hrAbout',
      component: () => import('./views/hrAbout.vue'),
      meta: {
        title: '悦享人事',
      },
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue'),
      meta: {
        title: '注册',
      },
    },
    {
      path: '/code',
      name: 'code',
      component: () => import(/* webpackChunkName: "about" */ './views/codeAbout.vue'),
      meta: {
        title: '邀请码注册',
      },
    },
    {
      path: '/modifyAbout',
      name: 'modifyAbout',
      component: () => import(/* webpackChunkName: "about" */ './views/modifyAbout.vue'),
      meta: {
        title: '修改信息',
      },
    },
    {
      path: '/hrModifyAbout',
      name: 'hrModifyAbout',
      component: () => import(/* webpackChunkName: "about" */ './views/hrModifyAbout.vue'),
      meta: {
        title: '修改信息',
      },
    },

    {
      path: '/index',
      name: 'index',
      redirect: '/index/new',
      component: () => import('./views/Index.vue'),
      children: [
        {
          path: 'new',
          name: 'new',
          component: () => import('./views/New.vue'),
          meta: {
            title: '新建',
          },
        },
        {
          path: 'history',
          name: 'history',
          component: () => import('./views/History.vue'),
          meta: {
            title: '发送记录',
          },
        },
        {
          path: 'help',
          name: 'help',
          component: () => import('./views/Help.vue'),
          meta: {
            title: '帮助中心',
          },
        },
        {
          path: 'provid',
          name: 'provid',
          component: () => import('./views/Provid.vue'),
          meta: {
            title: '我的套餐',
          },
          children: [
            {
              path: 'purchaserecord',
              name: 'purchaserecord',
              component: () => import('./components/Purchaserecord.vue'),
              meta: {
                title: '购买记录',
                activeMenu: '/index/provid'
              },
            },
          ]
        },
        {
          path: 'analysis',
          name: 'analysis',
          component: () => import('./views/analysis.vue'),
          meta: {
            title: '统计分析',
          },
        },
        {
          path: 'setting',
          name: 'setting',
          component: () => import('./views/Setting.vue'),
          meta: {
            title: '账号设置',
          },
        },
        {
          path: 'setup',
          name: 'setup',
          component: () => import('./views/setup.vue'),
          meta: {
            title: '设置',
          },
        },
        {
          path: 'system',
          name: 'system',
          component: () => import('./views/System.vue'),
          meta: {
            title: '系统集成',
          },
        },
        {
          path: 'buy',
          name: 'buy',
          component: () => import('./views/Buy.vue'),
          meta: {
            title: '购买套餐',
          },
        },

        {
          path: 'balance',
          name: 'balance',
          component: () => import('./views/Balance.vue'),
          meta: {
            title: '我的余额',
          },
        },
        {
          path: 'chosePayment',
          name: 'chosePayment',
          component: () => import('./views/chosePayment.vue'),
          meta: {
            title: '支付页面',
          },
        },
        {
          path: 'order',
          name: 'order',
          component: () => import('./views/Order.vue'),
          meta: {
            title: '我的订单',
          },
        },
      ]
    },
    {
      path: '/helpcenterindex',
      name: 'helpcenterindex',
      redirect: '/helpcenterindex/help',
      component: () => import('./views/helpcenterindex.vue'),
      children: [
        {
          path: 'help',
          name: 'help',
          component: () => import('./views/Help.vue'),
          meta: {
            title: '帮助中心',
          },
        },
        {
          path: 'smshelp',
          name: 'smshelp',
          component: () => import('./views/smsHelp.vue'),
          meta: {
            title: '短信帮助中心',
          },
        },
        {
          path: 'cardhelp',
          name: 'cardhelp',
          component: () => import('./views/cardHelp.vue'),
          meta: {
            title: '悦享心语帮助中心',
          },
        },
      ],
    },
    {
      path: '*',
      redirect: '/interpage',
    },
    // 官网跳转的帮助中心
    {
      path: '/helpcenter',
      name: 'helpcenter',
      component: () => import('./views/official/helpcenterindex.vue'),
      meta: {
        title: '帮助中心',
      },
    },
    {
      path: '/productList',
      name: 'productList',
      component: () => import('./views/official/productList.vue'),
      title: '产品列表',
    },
  ]
})
